module.exports = __webpack_public_path__ + "zilla-slab-latin-300.f39284f946c2a2f36c4fee5f002acccc.woff2";